//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cms from '~/mixins/cms';
import BookingPreparationSteps from '~/components/booking/preparation-steps.vue';

export default {
  cmsId: 'preparation-memos',
  name: 'preparation-memos',
  components: { BookingPreparationSteps },
  platforms: ['CABINET'],
  access: '*',
  mixins: [cms],
  computed: {
    selectedCountry () {
      return this.publicPage.selection?.country;
    },
    selectedAirport () {
      return this.publicPage.selection?.airport;
    },
    countryOptions () {
      return this.publicPage.options?.countries || [];
    },
    title () {
      return this.content.heading;
    },
    airportOptions () {
      return this.publicPage.options?.airports || [];
    },
    memo () {
      return this.content.memo;
    },
  },
  methods: {
    selectCountry (country) {
      if (country && country !== this.selectedCountry) {
        this.$router.push({ query: { country } });
      }
    },
    selectAirport (airport) {
      if (airport && airport !== this.selectedAirport) {
        this.$router.push({
          query: {
            country: this.selectedCountry,
            airport,
          },
        });
      }
    },
  },
};
